@if (url()) {
  <canvas
    #canvas
    width="200"
    height="200"
    class="border-ion-color-light block rounded border"
  ></canvas>
}
